export default {"src":"/_next/static/media/AAL.5938ebdf.svg","height":18,"width":18};